<template>
  <div class="navbar">
    <div class="container">
      <h2 class="title">Talki</h2>
      <div class="links">
        <router-link to="/home">Inicio</router-link>
        <a @click="logOut">Cerrar Sesión</a>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router';
export default {
  name: "NavBar",
  methods: {
    logOut() {
      localStorage.removeItem("token");
      localStorage.removeItem("userId");
      router.push("/");
    }
  }
};
</script>

<style scoped>
h2 {
  margin: 0;
}

.navbar {
  background-color: var(--main-color);
  padding: 20px 0;
  color: white;
}

.container {
  width: 70%;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.navbar a {
  cursor: pointer;
  font-weight: bold;
  color: var(--white);
  text-decoration: none;
  transition: all ease-out 0.2s;
  -webkit-transition: all ease-out 0.2s;
  -moz-transition: all ease-out 0.2s;
  -ms-transition: all ease-out 0.2s;
  -o-transition: all ease-out 0.2s;
}

.navbar a.router-link-exact-active {
  color: var(--white);
}

a:hover {
  transform: scale(1.05);
  -webkit-transform: scale(1.05);
  -moz-transform: scale(1.05);
  -ms-transform: scale(1.05);
  -o-transform: scale(1.05);
  color: var(--white);
}

.links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 5rem;
}

@media (max-width: 1100px) {
  .container {
    flex-direction: column;
  }

  .title {
    margin-bottom: 20px;
  }

  .links {
    flex-direction: column;
    gap: 20px;
  }
}
</style>